import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from '@digilize/shared/feature/components/src';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./views/main.module').then((m) => m.MainModule),
  },

  {
    path: 'not-found',
    component: NotFoundComponent,
    title: 'seo.title.not_found',
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
